import { JspVersion } from '@/state/context/ConfigAndDataContext';

type ConfigStatus = {
    url: string;
    api: string;
    les: string;
    vegkart: string;
};

export type RawConfig = {
    datakatalogen_url: string;
    fiksvegdata_url: string;
    changelog_url: string;
    eksport_url: string;
    eksport_x_url: string;
    maximum_number_of_objects_line: string;
    cluster_threshold_zoom_level_16: string;
    topo_layer: string;
    topo_style: string;
    topo_matrixset: string;
    topo_projection: string;
    url_topo: string | string[];
    cluster_distance: string;
    url_basemap: string;
    restapi_url: string;
    restapi_url_v3: string;
    vegnett_api_url: string;
    vegobjekt_api_url: string;
    zoom_level_detail_break: string;
    cluster_threshold: string;
    url_nib: string | string[];
    maximum_number_of_objects_point: string;
    maximum_number_of_roadnet: string;
    nib_layer: string;
    nib_style: string;
    nib_matrixset: string;
    nib_token?: string;
    nib_token_expiry?: string;
    cluster_distance_zoom_level_16: string;
    vegref_format_url: string;
    url_matrikkelen?: string;
    url_kanvas?: string;
    url_kanvas_mork?: string;
    url_basis?: string;
    url_basis_graatone?: string;
    url_openstreetmap?: string;
    status: ConfigStatus;
    placenames_page_size: string;
};

export class Config {
    constructor(
        readonly datakatalogen_url: string,
        readonly fiksvegdata_url: string,
        readonly changelog_url: string,
        readonly eksport_url: string,
        readonly eksport_x_url: string,
        readonly maximum_number_of_objects_line: number,
        readonly cluster_threshold_zoom_level_16: number,
        readonly topo_layer: string,
        readonly topo_style: string,
        readonly topo_matrixset: string,
        readonly topo_projection: string,
        readonly url_topo: string[],
        readonly cluster_distance: number,
        readonly url_basemap: string,
        readonly restapi_url: string,
        readonly restapi_url_v3: string,
        readonly vegnett_api_url: string,
        readonly vegobjekt_api_url: string,
        readonly zoom_level_detail_break: number,
        readonly cluster_threshold: number,
        readonly url_nib: string[],
        readonly maximum_number_of_objects_point: number,
        readonly maximum_number_of_roadnet: number,
        readonly nib_layer: string,
        readonly nib_style: string,
        readonly nib_matrixset: string,
        readonly nib_token: string,
        readonly nib_token_expiry: string,
        readonly cluster_distance_zoom_level_16: number,
        readonly vegref_format_url: string,
        readonly version: JspVersion,
        readonly url_matrikkelen: string | null = null,
        readonly url_kanvas: string | null = null,
        readonly url_kanvas_mork: string | null = null,
        readonly url_basis: string | null = null,
        readonly url_basis_graatone: string | null = null,
        readonly url_openstreetmap: string | null = null,
        readonly status: ConfigStatus,
        readonly url_brukAvData: string = 'http://www.vegdata.no/bruk-av-data/',
        readonly url_vegdataVegkart: string = 'http://www.vegdata.no/vegkart/',
        readonly url_informasjon: string = 'http://www.vegdata.no/vegkart/',
        readonly url_brukerveiledning: string = 'http://www.vegdata.no/vegkart/brukerveiledning/',
        readonly url_varBlog: string = 'http://vegdata.no/',
        readonly url_SSRI: string = 'https://api.kartverket.no/stedsnavn/v1/',
        readonly testMode: boolean = true,
        readonly doBlur: boolean = true,
        readonly logDebug: boolean = false,
        readonly ajaxTimeout: number = 30000,
        readonly ventetidImsForBrukerKanAvbryteForesporsler: number = 3000,
        readonly searchDelay: number = 500,
        readonly antallResultater: number = 1000,
        readonly minZoomLevel: number = 3,
        readonly maxZoomLevelRegion: number = 4,
        readonly maxZoomLevelCounty: number = 6,
        readonly maxNumberOfRoadrefsShown: number = 5,
        readonly geometritoleranse: number = 10,
        readonly placenames_page_size: number = 20
    ) {}
}

export function parseConfig(version: JspVersion, config: RawConfig): Config {
    return new Config(
        config.datakatalogen_url,
        config.fiksvegdata_url,
        config.changelog_url,
        config.eksport_url,
        config.eksport_x_url,
        parseInt(config.maximum_number_of_objects_line, 10),
        parseInt(config.cluster_threshold_zoom_level_16, 10),
        config.topo_layer,
        config.topo_style,
        config.topo_matrixset,
        config.topo_projection,
        Array.isArray(config.url_topo) ? config.url_topo : [config.url_topo],
        parseInt(config.cluster_distance, 10),
        config.url_basemap,
        config.restapi_url,
        config.restapi_url_v3,
        config.vegnett_api_url,
        config.vegobjekt_api_url,
        parseInt(config.zoom_level_detail_break, 10),
        parseInt(config.cluster_threshold, 10),
        Array.isArray(config.url_nib) ? config.url_nib : [config.url_nib],
        parseInt(config.maximum_number_of_objects_point, 10),
        parseInt(config.maximum_number_of_roadnet, 10),
        config.nib_layer,
        config.nib_style,
        config.nib_matrixset,
        config.nib_token ?? '',
        config.nib_token_expiry ?? '',
        parseInt(config.cluster_distance_zoom_level_16, 10),
        config.vegref_format_url,
        version,
        config.url_matrikkelen,
        config.url_kanvas,
        config.url_kanvas_mork,
        config.url_basis,
        config.url_basis_graatone,
        config.url_openstreetmap,
        config.status,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        parseInt(config.placenames_page_size, 10)
    );
}
